const experiments = {
  NEW_NAVIGATION: {
    name: 'new_navigation_exp_2',
    variants: {
      control: 'new_navigation_exp_2_control',
      v1: 'new_navigation_exp_2_v1',
    },
  },
  GOOGLE_REGISTER: {
    name: 'google_register',
    variants: {
      control: 'google_register_control',
      v1: 'google_register_v1',
    },
  },
  PICKUP_BADGE_FR: {
    name: 'Pickup_badge_experiment_FR',
    variants: {
      control: 'Pickup_badge_experiment_control',
      v1: 'Pickup_badge_experiment_FR_v1',
    },
  },
  PHOTOS_AVOIDANCE: {
    name: 'photos_avoidance',
    variants: {
      control: 'photos_avoidance_control',
      v1: 'photos_avoidance_v1',
    },
  },
  STICKY_CTA: {
    name: 'sticky_cta',
    variants: {
      control: 'sticky_cta_control',
      v1: 'sticky_cta_v1',
    },
  },
  GRW_BILLING_FIX: {
    name: 'grw_BillingFix',
    variants: {
      control: 'grw_BillingFix_control',
      v1: 'grw_BillingFix_v1',
    },
  },
  ANCHOR_FREQUENCY: {
    name: 'grw_AnchorFrequency',
    variants: {
      control: 'grw_AnchorFrequency_control',
      v1: 'grw_AnchorFrequency_v1',
      v2: 'grw_AnchorFrequency_v2',
    },
  },
  FACTORING_PAY: {
    name: 'grw_FactoringPay',
    variants: {
      control: 'grw_FactoringPay_control',
      v1: 'grw_FactoringPay_v1',
    },
  },
} as const;

export {experiments};
